import http from '@/server/httpServer.js'

/**
 * 用户登录
 * @return {promise}
 *
 */
/* 用户登录通过手机号码 */
export const userLoginByMobile = (data) => {
    return http({ url: '/gzzc/user/userLoginByMobile', method: 'post' }, data)
}

/* 校验首次登录 */
export const checkIsFirstLogin = (data) => {
    return http({ url: '/gzzc/user/checkIsFirstLogin', method: 'post' }, data)
}

/* 账号信息查询 */
export const searchUserInfoByPhone = (data) => {
    return http({ url: '/gzzc/user/searchUserInfoByPhone', method: 'post' }, data)
}

/* 获取短信验证码 */
export const getSMSCode = (data) => {
    return http({ url: '/gzzc/user/getSMSCode', method: 'post' }, data)
}

/* 重置密码 */
export const resetUserPassWord = (data) => {
    return http({ url: '/gzzc/user/resetUserPassWord', method: 'post' }, data)
}

/* 用户退出登录 */
export const loginOut = (data) => {
    return http({ url: '/gzzc/user/loginOut', method: 'post' }, data)
}

/* 刷新token */
export const refreshToken = (data) => {
    return http({ url: '/gzzc/user/refreshToken', method: 'post' }, data)
}

/* 普通用户注册 */
export const registerUser = (data) => {
    return http({ url: '/gzzc/user/registerUser', method: 'post' }, data)
}

/* 修改密码 */
export const updatePassword = (data) => {
        return http({ url: '/gzzc/user/updatePassword', method: 'post' }, data)
    }
    /* 显示实名认证⼆维码 */
export const showRealNameVerifyQRCode = (data, jsonfile) => {
        return http({ url: `/gzzc/user/showRealNameVerifyQRCode?${jsonfile}`, method: 'get' }, data)
    }
    /* PC端定时获取实名认证状态 */
export const getRealNameVerifyStatus = (data) => {
        return http({ url: '/gzzc/user/getRealNameVerifyStatus', method: 'post' }, data)
    }
    /* PC端定时获取实名认证状态-广州仲裁 */
export const getRealNameVerifyStatusGzzc = (data) => {
    return http({ url: '/gzzc/user/getRealNameVerifyStatusGzzc', method: 'post' }, data)
}

/* 获取空间是否结束 */
export const getCaseStatus = (data) => {
    return http({ url: '/scavenger/meeting/getMeetingStatus', method: 'post' }, data)
}

/* 结束案件 异步庭审*/
export const closeMeeting = (data) => {
    return http({ url: '/gzzc/trial/closeMeeting', method: 'post' }, data)
}

/* 重新开启案件*/
export const updateCsaeStatus = (data) => {
    return http({ url: '/scavenger/trial/updateCsaeStatus', method: 'get' }, data)
}

/* 结束案件 异步调解+在线送达*/
export const closeMeetingSecond = (data) => {
    return http({ url: `/scavenger/trial/closeMeetingSecond?meetingId=${data.meetingId}`, method: 'get' })
}